<template>
    <div class="container">
        <div class="agreement" v-html="agreementData"></div>
        <div class="footer">
            <van-button type="info" round color="#FA2D1A" block @click="clickAgreement">我已阅读</van-button>
        </div>
    </div>
</template>
<script>
import { getActivityRuleContent } from "@/api/join";
export default {
    name:'cancellationNotice',
    data(){
        return{
            agreementData:'',
        }
    },
    created(){
        this._getActivityRuleContent()
    },
    methods:{
        async _getActivityRuleContent(){
            const res = await getActivityRuleContent({type:33})
            if(res.appStatus.errorCode == 0){
                this.agreementData = res.content.content;
            }else{
                this.$toast(res.appStatus.message);
            }
        },
        clickAgreement(){
            this.$router.go(-1)
        },
    },
}
</script>
<style lang="scss" scoped>
    .container{
        // height: 100%;
        height: calc(100vh - 46px);
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        .agreement{
            height: 100%;
            overflow-y: auto;
            flex: 1;
        }
        .footer{
            padding: 22px 0 20px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            /deep/.van-button{
                width: 345px;;
            }
        }
    }
</style>